import { render } from "./PersianTimeField.vue?vue&type=template&id=294f9964"
import script from "./PersianTimeField.vue?vue&type=script&lang=js"
export * from "./PersianTimeField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianTimeField.vue"]])

export default __exports__